import { Appearance, DomainResponse, FavIcon, GatingConfigurationResponse, NotificationPreferences, SiteVerification, StoryboardPageSummary } from ".";
import { MediaResponse } from "./primitives";
import { TrackingPixel } from "./tracking-pixel";

export const STORYBOARD_TYPES = {
  INTERACTIVE_CONTENT: "INTERACTIVE_CONTENT",
  INTERACTIVE_CONTENT_V2: "INTERACTIVE_CONTENT_V2",
  LANDING_PAGE: "LANDING_PAGE",
  RESOURCE_CENTER: "RESOURCE_CENTER",
  SPATIAL: "SPATIAL",
  SLIDE_STORYBOARD: "SLIDE_STORYBOARD",
  FLIP_BOOK: "FLIP_BOOK",
} as const;

export type StoryboardType = keyof typeof STORYBOARD_TYPES;

export const STORYBOARD_STATUSES = {
  NONE: "NONE",
  CREATING_SNAPSHOT: "CREATING_SNAPSHOT",
  RESTORING_SNAPSHOT: "RESTORING_SNAPSHOT",
  CREATING_PPT: "CREATING_PPT",
} as const;

export type StoryboardStatus = keyof typeof STORYBOARD_STATUSES;

export type ViewerMode = "BINGE" | "LIGHTBOX";

export interface StoryboardResponse {
  id: string;
  name: string;
  description?: string;
  type: StoryboardType;
  role?: string;
  status?: StoryboardStatus;
  page?: StoryboardPageSummary;
  social?: MediaResponse | null;
  favIcon?: FavIcon | null;
  trackingPixels?: TrackingPixel[];
  siteVerification?: SiteVerification;
  gatingConfigurations?: GatingConfigurationResponse[];
  appearance?: Appearance;
  notifications?: NotificationPreferences;
  passwordEnabled: boolean;
  password?: string;
  excludeFromSearch: boolean;
  domain?: DomainResponse | null;
  customScript?: string;
  viewer?: ViewerMode;
  darkViewer: boolean;
  createdDate?: number;
  modifiedDate?: number;
}

export type StoryboardUpdateRequest = Partial<StoryboardResponse> & {
  storyBoardLevelIndex?: boolean;
  /** Flat vanity-URL field the server expects (derived from page.canonical). */
  alias?: string;
};
